'use client'
import dynamic from 'next/dynamic'
// const AirportFleet = dynamic(() => import('@/components/AirportFleet'))
const CarRentalsFleet = dynamic(() => import('@/components/CarRentalsFleet'))
const ChauffeurServicesFleet = dynamic(
  () => import('@/components/ChauffeurServicesFleet')
)
import { useTranslations } from 'next-intl'
import SearchSection from './SearchSection'
import { useEffect, useState } from 'react'
import { useFleetList, useGeoCodeAddress } from 'src/lib/api/homeService'
import { ConstantService } from 'src/constants/apiPaths'
import { CompilerProvider } from 'src/lib/api/complierProvider'
import { HelperService } from 'src/lib/api'
import GoldLinkButton from '@/components/GoldLinkButton'
import AirportFleet from '@/components/AirportFleet'

const AllFleets = ({ initialFleetData }) => {
  const [formData, setFormData] = useState({ addressObj: {}, currencyObj: {} })
  const [isNoData, setIsNoData] = useState(false)
  const [form, setForm] = useState({})
  const [changeCurrLoading, setChangeCurrLoading] = useState(false)
  const helperService = new HelperService()
  const [searchedFleetData, setSearchedFleetData] = useState(initialFleetData)
  const compilerProviderInst = new CompilerProvider(helperService)
  const t = useTranslations('fleet-page')
  const handleCurrencyChange = (selectedCurr) => {
    setChangeCurrLoading(true)
    setFormData({ ...formData, currencyObj: selectedCurr })
    changeCurrency(selectedCurr)
  }
  const currencyList = ConstantService.currency
  const selectedCurrency = Object.keys(formData.currencyObj).length
    ? formData.currencyObj
    : currencyList[0]
  // const { geoData, error, isLoading } = useGeoCodeAddress(city || 'london')
  const { fetchFleetList } = useFleetList(form)
  const setAddress = (addrObj) => {
    const addr = addrObj
    const addrKeys = Object.keys(addrObj)
    let data = {
      address: addr.address,
      coordinates: addr.coordinates,
      placeId: addr.placeId,
      currency: selectedCurrency.value,
    }
    getFleetData(data)
  }
  const changeCurrency = async (currency) => {
    try {
      const isaddressObj = Object.keys(formData.addressObj).length
      const data = {
        address: isaddressObj
          ? formData.addressObj.address
          : 'London-England-GB',
        coordinates: isaddressObj
          ? formData.addressObj.coordinates
          : '51.5074/-0.1278',
        placeId: isaddressObj
          ? formData.addressObj.placeId
          : ConstantService.cityIdLondon,
        currency: currency.value,
      }

      await getFleetData(data)
    } catch (error) {
      console.log('Error changing currency:', error)
    } finally {
      setTimeout(() => {
        setChangeCurrLoading(false) // Remove the loader after a slight delay
      }, 300)
    }
  }

  useEffect(() => {
    if (Object.keys(formData.addressObj).length) {
      setAddress(formData.addressObj)
    }
  }, [formData.addressObj])

  const getFleetData = async (newForm) => {
    try {
      const fetchedData = await fetchFleetList(newForm) // Pass newForm directly
      const fleetData = compilerProviderInst.constructFleetData(
        fetchedData.data
      )
      if (!Object.keys(fleetData).length) {
        setIsNoData(true)
      } else setIsNoData(false)
      setSearchedFleetData(fleetData)
    } catch (error) {
      console.log('Error fetching fleet list:', error)
    }
  }

  return (
    <>
      <section>
        <div className='container pt-24 mb-12'>
          <SearchSection
            t={t}
            setFormData={setFormData}
            formData={formData}
            handleCurrencyChange={handleCurrencyChange}
          />
        </div>
        {!!Object.keys(searchedFleetData.airport).length && (
          <div className='container'>
            <div className='grid grid-cols-12'>
              <div className='col-span-8'>
                <h3 className='text-[30px] md:text-[28px] font-light mb-6'>
                  {t('airport-transfers.title')}
                </h3>
                <p className='text-[18px] md:text-[16px] font-light mb-12 leading-[1.6]'>
                  {t('airport-transfers.description')}
                </p>
              </div>
            </div>
            <AirportFleet
              isShowSkeletonTabs
              isShowRate
              changeCurrLoading={changeCurrLoading}
              isNoData={isNoData}
              searchedFleetData={searchedFleetData.airport}
            />
          </div>
        )}
      </section>
      {!!searchedFleetData.Chauffeur.length && (
        <section>
          <div className='container pt-12'>
            <div className='grid grid-cols-12'>
              <div className='col-span-8'>
                <h3 className='text-[30px] md:text-[28px] font-light mb-6'>
                  {t('BTH.title')}
                </h3>
                <p className='text-[18px] md:text-[16px] font-light mb-12 leading-[1.6]'>
                  {t('BTH.description')}
                </p>
              </div>
            </div>
            <ChauffeurServicesFleet
              isShowRate
              changeCurrLoading={changeCurrLoading}
              isFleetByLocationPage
              isHideTabs
              searchedFleetData={searchedFleetData.Chauffeur}
            />
          </div>
        </section>
      )}
      <div className='container text-center mt-12 mb-24'>
        <GoldLinkButton
          isNewTab
          href='https://business.rolzo.com/auth/login'
          hasGoldBackground
          text='Book now'
        />
      </div>
    </>
  )
}

export default AllFleets
